import React from 'react';

import { MediaControllerContext } from '@/lib/contexts/media-controller';

export const useMediaController = () =>
  React.useContext(MediaControllerContext);
